export const API_ERRORS = {
  USER_ALREADY_EXISTS: "API_USER_ALREADY_EXISTS",
  INCORRECT_USERNAME_PASSWORD: "API_INCORRECT_USERNAME_PASSWORD",
  INVALID_INVITE_CODE: "API_INVALID_INVITE_CODE",
  UNKOWN_ERROR: "API_UNKNOWN_ERROR",
};
